import { CompanionServiceRate } from '../types';

export interface ServiceDefinition {
  id: string;
  name: string;
  category: string;
  description: string;
  defaultRate: number;
  iconName: string;
}

export const ALL_COMPANION_SERVICES: ServiceDefinition[] = [
  {
    id: 'movies',
    name: 'Movies',
    category: 'Entertainment & Arts',
    description: 'Cinema, film festivals, premiere shows & movie discussion companion',
    defaultRate: 800,
    iconName: 'Film'
  },
  {
    id: 'shopping',
    name: 'Shopping',
    category: 'Lifestyle & Social',
    description: 'Personal styling advice, mall companion, fitting opinion & shopping trips',
    defaultRate: 1000,
    iconName: 'ShoppingBag'
  },
  {
    id: 'travel',
    name: 'Travel',
    category: 'Adventure & Travel',
    description: 'Weekend getaways, road trips, hill station tours & sightseeing partner',
    defaultRate: 1500,
    iconName: 'Plane'
  },
  {
    id: 'medical-help',
    name: 'Medical Help',
    category: 'Care & Assistance',
    description: 'Hospital visits, OPD queue assistance, prescription handling & supportive care',
    defaultRate: 1200,
    iconName: 'Stethoscope'
  },
  {
    id: 'elder-care',
    name: 'Elder Care',
    category: 'Care & Assistance',
    description: 'Gentle companionship, pleasant conversation, walking support & elder care',
    defaultRate: 1200,
    iconName: 'HeartHandshake'
  },
  {
    id: 'domestic-help',
    name: 'Domestic Help',
    category: 'Care & Assistance',
    description: 'Home organization support, grocery run accompaniment & task assistance',
    defaultRate: 1000,
    iconName: 'Home'
  },
  {
    id: 'business-events',
    name: 'Business Events',
    category: 'Corporate & Business',
    description: 'Corporate networking, seminars, conferences, galas & formal business mixers',
    defaultRate: 2000,
    iconName: 'Briefcase'
  },
  {
    id: 'outdoor-events',
    name: 'Outdoor Events',
    category: 'Outdoors & Active',
    description: 'Fairs, food festivals, open-air carnivals, botanical walks & public events',
    defaultRate: 1200,
    iconName: 'Sun'
  },
  {
    id: 'baking-cooking',
    name: 'Baking/Cooking',
    category: 'Culinary & Creative',
    description: 'Shared kitchen baking, pastry making, recipe experiments & cooking sessions',
    defaultRate: 1100,
    iconName: 'UtensilsCrossed'
  },
  {
    id: 'sporting-events',
    name: 'Sporting Events',
    category: 'Sports & Games',
    description: 'Cricket stadium matches, football derbies, live tennis tournaments & cheering',
    defaultRate: 1200,
    iconName: 'Trophy'
  },
  {
    id: 'playing-sports',
    name: 'Playing Sports',
    category: 'Sports & Games',
    description: 'Badminton, tennis, gym workout partner, jogging, swimming or cycling',
    defaultRate: 1300,
    iconName: 'Activity'
  },
  {
    id: 'comedy-club',
    name: 'Comedy Club',
    category: 'Entertainment & Nightlife',
    description: 'Stand-up comedy nights, open mics, comedy lounge visits & laughs',
    defaultRate: 1000,
    iconName: 'Laugh'
  },
  {
    id: 'going-to-bar',
    name: 'Going to Bar',
    category: 'Dining & Nightlife',
    description: 'Cocktail bars, microbreweries, wine tasting & polite evening pub companion',
    defaultRate: 1500,
    iconName: 'Wine'
  },
  {
    id: 'hanging-out',
    name: 'Hanging Out',
    category: 'Social & Casual',
    description: 'Casual coffee meets, park strolls, friendly conversations & relaxing vibes',
    defaultRate: 800,
    iconName: 'Coffee'
  },
  {
    id: 'tutoring',
    name: 'Tutoring',
    category: 'Education & Learning',
    description: 'Conversational language practice, study buddy, homework & skill guidance',
    defaultRate: 1000,
    iconName: 'BookOpen'
  },
  {
    id: 'clubbing',
    name: 'Clubbing',
    category: 'Dining & Nightlife',
    description: 'High-energy dance clubs, DJ party nights, VIP lounges & weekend nightlife',
    defaultRate: 1800,
    iconName: 'Sparkles'
  },
  {
    id: 'dinner',
    name: 'Dinner',
    category: 'Dining & Social',
    description: 'Fine dining restaurants, candlelit bistro dates, street food trails & dinner dates',
    defaultRate: 1200,
    iconName: 'Utensils'
  },
  {
    id: 'music',
    name: 'Music',
    category: 'Entertainment & Arts',
    description: 'Live concerts, acoustic gigs, jazz festivals, indie music gigs & orchestra',
    defaultRate: 1100,
    iconName: 'Music'
  },
  {
    id: 'culture',
    name: 'Culture',
    category: 'Arts & Culture',
    description: 'Museums, art galleries, historical monument walks & cultural festivals',
    defaultRate: 1000,
    iconName: 'Landmark'
  },
  {
    id: 'parties',
    name: 'Parties',
    category: 'Social & Celebrations',
    description: 'Birthday bashes, anniversary parties, social gatherings & celebrations plus-one',
    defaultRate: 1600,
    iconName: 'PartyPopper'
  },
  {
    id: 'tourist-guide',
    name: 'Tourist Guide',
    category: 'Travel & Sightseeing',
    description: 'Local monument tours, heritage walks, city sightseeing & authentic cultural exploration',
    defaultRate: 1200,
    iconName: 'Compass'
  },
  {
    id: 'driver',
    name: 'Driver',
    category: 'Travel & Transit',
    description: 'Licensed chauffeur, personal driving, city navigation, road trips & private transit accompaniment',
    defaultRate: 1000,
    iconName: 'Car'
  }
];

export const getDefaultCompanionServices = (baseRate: number = 1500): CompanionServiceRate[] => {
  return ALL_COMPANION_SERVICES.map((srv) => ({
    id: srv.id,
    name: srv.name,
    category: srv.category,
    description: srv.description,
    isAvailable: true,
    hourlyRate: srv.defaultRate || baseRate
  }));
};
